import { version } from "react";
import api from "../utils/api"; // Your configured Axios instance
import UserRoles from "../constants/userRoles.js";

// COMPANY START

export const getCompanyDetails = async (user = null) => {
  try {
    let onlyWhereIAmValidator,
      onlyWhereIAmManager = false;

    if (user) {
      onlyWhereIAmValidator = user.userRole.id === UserRoles.VALIDATOR.id;
      onlyWhereIAmManager = user.userRole.id === UserRoles.MANAGER.id;
    }

    const res = await api.get(`/api/company/detail`, {
      params: {
        includeIndustries: true,
        includeCompanyContacts: true,
        includeOfferings: true,
        onlyWhereIAmValidator,
        onlyWhereIAmManager,
      },
    });
    return res.data;
  } catch (error) {
    console.error("Failed to fetch company details:", error);
    throw error;
  }
};

export const getCompanyDetailsById = async (companyId) => {
  try {
    const res = await api.get(`/api/company/detail/${companyId}`, {
      params: {
        includeIndustries: true,
        includeCompanyContacts: true,
        includeOfferings: true,
      },
    });
    return res.data;
  } catch (error) {
    console.error("Failed to fetch company details:", error);
    throw error;
  }
};

export const updateCompanyDetail = async (payload) => {
  try {
    const response = await api.put(
      "/api/company/detail",
      JSON.stringify(payload)
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to save details");
  }
};

export const saveCompanyDetail = async (payload) => {
  try {
    const response = await api.post("/api/company", payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to save details");
  }
};

// COMPANY END

// BRANCH START

export const getCompanyBranchById = async (companyId, version) => {
  try {
    const response = await api.get(
      `/api/company/company-branch?companyId=${companyId}&version=${version}`
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch details");
  }
};

export const saveCompanyBranch = async (payload) => {
  try {
    const response = await api.post(`/api/company/company-branch`, payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to save details");
  }
};

export const updateCompanyBranch = async (payload) => {
  try {
    const response = await api.put(`/api/company/company-branch`, payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to save details");
  }
};

// BRANCH END

// ADDRESS START
export const getCompanyAddressById = async (companyId, version) => {
  try {
    const response = await api.get(
      `/api/company/address?companyId=${companyId}&version=${version}`
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch details");
  }
};

export const createCompanyAddress = async (payload) => {
  try {
    const response = await api.post(`/api/company/address`, payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to save details");
  }
};

export const updateCompanyAddress = async (payload) => {
  try {
    const response = await api.put(`/api/company/address`, payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to save details");
  }
};

// ADDRESS END

// IMPORT DETAILS START

// // Function to get company import detail mapping (GET request)
export const getCompanyImportDetail = async (companyId, version) => {
  try {
    const response = await api.get("/api/company/import-detail", {
      params: {
        companyId,
        version,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to get company import detail"
    );
  }
};

// Function to send company import detail mapping (POST request)
export const saveCompanyImportDetail = async (importDetail) => {
  try {
    const response = await api.post("/api/company/import-detail", importDetail);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to save company import detail"
    );
  }
};

// Function to update company import detail mapping (PUT request)
export const updateCompanyImportDetail = async (importDetail) => {
  try {
    const response = await api.put(`/api/company/import-detail`, importDetail);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update company import detail"
    );
  }
};

// Function to delete a company import detail mapping (DELETE request)
export const deleteCompanyImportDetail = async (companyId, version, id) => {
  try {
    const response = await api.delete(
      `/api/company/import-detail?companyId=${companyId}&version=${version}&id=${id}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to delete company import detail"
    );
  }
};

// IMPORT DETAILS END

//FINANCIAL ABILITY START

// Function to create company financial ability (POST request)
export const createCompanyFinancialAbility = async (
  companyId,
  version,
  annualTurnOver,
  netWorth,
  profitLoss,
  bankName,
  bankAccountNumber,
  bankAddress,
  historyOfDebts
) => {
  try {
    const response = await api.post("/api/company/financial-ability", {
      companyId,
      version,
      annualTurnOver,
      netWorth,
      profitLoss,
      bankDetail: {
        bankName,
        bankAccountNumber,
        bankAddress,
      },
      historyOfDebts,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to create company financial ability"
    );
  }
};

// Function to update company financial ability (PUT request)
export const updateCompanyFinancialAbility = async (
  id,
  companyId,
  version,
  annualTurnOver,
  netWorth,
  profitLoss,
  bankName,
  bankAccountNumber,
  bankAddress,
  historyOfDebts
) => {
  try {
    const response = await api.put(`/api/company/financial-ability/${id}`, {
      companyId,
      version,
      annualTurnOver,
      netWorth,
      profitLoss,
      bankDetail: {
        bankName,
        bankAccountNumber,
        bankAddress,
      },
      historyOfDebts,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to update company financial ability"
    );
  }
};

// Function to get company financial ability by companyId and version (GET request)
export const getCompanyFinancialAbility = async (companyId, version) => {
  try {
    const response = await api.get("/api/company/financial-ability", {
      params: {
        companyId,
        version,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to get company financial ability"
    );
  }
};
//FINANCIAL ABILITY END

//ADDITIONAL INFO START

// Function to create company additional info (POST request)
export const saveAdditionalInfo = async (
  companyId,
  version,
  overallSelfAssessment,
  promoterQualification,
  acceptedPaymentTerms,
  keyAgreements
) => {
  try {
    const response = await api.put("/api/company/additional-info", {
      companyId,
      version,
      overallSelfAssessment,
      promoterQualification,
      acceptedPaymentTerms,
      keyAgreements,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to create company additional info"
    );
  }
};

// Function to get company additional info by companyId and version (GET request)
export const getAdditionalInfoById = async (companyId, version) => {
  try {
    const response = await api.get("/api/company/additional-info", {
      params: {
        companyId,
        version,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to get company additional info"
    );
  }
};

export const updateAdditionalInfo = async (payload) => {
  try {
    const response = await api.put("/api/company/additional-info", payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update additional info"
    );
  }
};

// Function to upload company additional info document (POST request with multipart/form-data)
export const uploadCompanyAdditionalInfoDocument = async (
  companyId,
  version,
  additionalInfold,
  file
) => {
  try {
    const formData = new FormData();
    formData.append("companyId", companyId);
    formData.append("version", version);
    formData.append("additionalInfold", additionalInfold);
    formData.append("file", file);

    const response = await api.post(
      "/api/company/additional-info/upload",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to upload company additional info document"
    );
  }
};

// Function to download company additional info document (GET request)
export const downloadCompanyAdditionalInfoDocument = async (
  companyId,
  version,
  additionalInfold,
  documentId
) => {
  try {
    const response = await api.get("/api/company/additional-info/download", {
      params: {
        companyId,
        version,
        additionalInfold,
        documentId,
      },
      responseType: "blob", // Important for downloading files
    });
    return response; // Return the entire response for blob handling
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to download company additional info document"
    );
  }
};

// Function to delete company additional info document (DELETE request)
export const deleteCompanyAdditionalInfoDocument = async (
  companyId,
  version,
  additionalInfold,
  documentId
) => {
  try {
    const response = await api.delete("/api/company/additional-info/document", {
      params: {
        companyId,
        version,
        additionalInfold,
        documentId,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to delete company additional info document"
    );
  }
};

//ADDITIONAL INFO END

// Company Export Detail Services
export const getCompanyExportDetail = async (companyId, version) => {
  try {
    const response = await api.get(
      `/api/company/export-detail?companyId=${companyId}&version=${version}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching company export details:", error);
    throw error;
  }
};

export const saveCompanyExportDetail = async (payload) => {
  try {
    const response = await api.post("/api/company/export-detail", payload);
    return response.data;
  } catch (error) {
    console.error("Error saving company export detail:", error);
    throw error;
  }
};

export const updateCompanyExportDetail = async (payload) => {
  try {
    const response = await api.put("/api/company/export-detail", payload);
    return response.data;
  } catch (error) {
    console.error("Error updating company export detail:", error);
    throw error;
  }
};

export const deleteCompanyExportDetail = async (companyId, versionId, id) => {
  try {
    const response = await api.delete(
      `/api/company/export-detail?companyId=${companyId}&version=${versionId}&id=${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting company export detail:", error);
    throw error;
  }
};

// Additional Export Import Detail Services
export const getAdditionalExportImportDetail = async (companyId, version) => {
  try {
    const response = await api.get(
      `/api/company/exim-additional-info?companyId=${companyId}&version=${version}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching additional export/import details:", error);
    throw error;
  }
};

export const saveAdditionalExportImportDetail = async (payload) => {
  try {
    const response = await api.post(
      "/api/company/exim-additional-info",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error saving additional export/import detail:", error);
    throw error;
  }
};

export const updateAdditionalExportImportDetail = async (payload) => {
  try {
    const response = await api.put(
      "/api/company/exim-additional-info",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error updating additional export/import detail:", error);
    throw error;
  }
};

export const assignCompanyToValidator = async (payload) => {
  try {
    const response = await api.post(`/api/company/assign-validator`, payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to save details");
  }
};

export const getAcceptedPaymentTerms = async () => {
  try {
    const response = await api.get(`/api/acceptedpaymentterms/get`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch details");
  }
};

export const getCompanyClient = async (companyId, version) => {
  try {
    const response = await api.get(
      `/api/company/company-client?companyId=${companyId}&version=${version}`
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch details");
  }
};

export const saveCompanyClient = async (payload) => {
  try {
    const response = await api.post(`/api/company/company-client`, payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch details");
  }
};

export const updateCompanyClient = async (payload) => {
  try {
    const response = await api.put(`/api/company/company-client`, payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch details");
  }
};

export const submitCompanyForm = async (companyId, version) => {
  try {
    const response = await api.put(`/api/company/submit-application-form`, {
      companyId,
      version,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch details");
  }
};

export const updateCompanyFormStatus = async (
  companyId,
  version,
  formStatus,
  companyRemark
) => {
  try {
    const response = await api.put(`/api/company/manager/set-status`, {
      companyId,
      version,
      formStatus,
      companyRemark,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch details");
  }
};

export const getDahboardStats = async (user = null) => {
  try {
    let validatorId = 0,
      managerId = 0;
    if (user) {
      const role = user.userRole.id;
      validatorId = role === 3 ?? role;
      validatorId = role === 2 ?? role;
    }
    let response = await getCompanyDetails(user);
    if (validatorId > 0) {
      response = response.filter((item) =>
        item.assignedValidators.some(
          (validator) => validator.userId === validatorId
        )
      );
    }
    const result = {
      totalForms: response.length || 0,
      approvedForms:
        response.length > 0
          ? response?.filter((x) => x?.applicationStatus?.id === 6)?.length || 0
          : 0,
      pendingForms:
        response.length > 0
          ? response?.filter((x) => x?.applicationStatus?.id === 3)?.length || 0
          : 0,
      rejectedForms:
        response.length > 0
          ? response?.filter((x) => x?.applicationStatus?.id === 7)?.length || 0
          : 0,
    };
    return result;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch details");
  }
};
